/**
 * Default folder structure seeded into every NEW project's Documents section.
 * Stored as French labels in the DB (current data is French).
 * i18n display can be layered on top later — flag as follow-up.
 *
 * Structure: 3 top-level parent folders, each with nested children.
 * sort_order is informational only (project_folders has no sort_order column);
 * alphabetical order of the French names naturally matches the desired display order:
 *   1. Démarrage / Startup
 *   2. Documents de projet / Project documents
 *   3. Fin de projet / Project closeout
 */
export const DEFAULT_PROJECT_FOLDERS = [
  {
    name_fr: 'Démarrage',
    name_en: 'Startup',
    sort_order: 1,
    children: [
      { name_fr: 'Assurance et cautionnement', name_en: 'Insurance and bonding', sort_order: 1 },
      { name_fr: 'Contrat & bon de commande', name_en: 'Contract & purchase order', sort_order: 2 },
      { name_fr: 'Formulaire de dénonciation contrat', name_en: 'Contract notice form', sort_order: 3 },
      { name_fr: 'Ouverture de projet CCQ et CNESST', name_en: 'CCQ and CNESST project opening', sort_order: 4 },
      { name_fr: 'Programme de prévention', name_en: 'Prevention program', sort_order: 5 },
    ],
  },
  {
    name_fr: 'Documents de projet',
    name_en: 'Project documents',
    sort_order: 2,
    children: [
      { name_fr: "Dessin d\'atelier", name_en: 'Shop drawings', sort_order: 1 },
      { name_fr: 'Plan et devis', name_en: 'Plans and specifications', sort_order: 2 },
    ],
  },
  {
    name_fr: 'Fin de projet',
    name_en: 'Project closeout',
    sort_order: 3,
    children: [
      { name_fr: 'Liste de déficiences', name_en: 'Deficiency list', sort_order: 1 },
      { name_fr: "Manuels d\'opération", name_en: 'Operation manuals', sort_order: 2 },
      { name_fr: 'Garanties', name_en: 'Warranties', sort_order: 3 },
    ],
  },
];
